<template>
  <v-app id="inspire">
    <Navigation />
    <Toolbar />
    <v-content>
      <v-container fluid fill-height>
        <v-layout>
          <v-flex xs12>
            <Breadcrumbs />
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import Navigation from "../components/Navigation.vue";
import Toolbar from "../components/Toolbar.vue";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  components: {
    Navigation,
    Toolbar,
    Breadcrumbs
  }
};
</script>
